var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement-page"},[_c('h1',[_vm._v(_vm._s(_vm.$t('precautions')))]),_c('h3',[_vm._v(_vm._s(_vm.title1))]),_c('pre',[_vm._v(_vm._s(_vm.agreement1))]),_c('h3',[_vm._v(_vm._s(_vm.title2))]),_c('pre',[_vm._v(_vm._s(_vm.agreement2))]),_c('h3',[_vm._v(_vm._s(_vm.title3))]),_c('pre',[_vm._v(_vm._s(_vm.agreement3))])])
}
var staticRenderFns = []

export { render, staticRenderFns }